import sendMetaPixelEvent from '@util/sendMetaPixelEvent';
import sendGtmEvent from '@util/sendGtmEvent';
import { actionIds as actionIdsList } from './actionList';

export const actionIds = actionIdsList;

export default function sendActionEvents(config = { events: [], action_id: null }) {
  const { events, action_id: actionId } = config;

  if (typeof window === "undefined") return;
  if (!actionId) return console.warn("No action ID to send");
  if (!events || !events.length) return console.warn("No events to send");

  const actionEvents = events.filter(event => event.action_id === actionId);

  actionEvents.forEach(event => {
    if (event.provider === "meta_pixel") {
      sendMetaPixelEvent(event.event_category, event.event_action, event.event_value || {});
    } else if (event.provider === "gtm") {
      sendGtmEvent(event.event_category, event.event_action, event.event_value || {});
    }
  });
}